export var LoadingState;
(function (LoadingState) {
    LoadingState["NotLoaded"] = "not-loaded";
    LoadingState["Loading"] = "loading";
    LoadingState["LoadingPartial"] = "loading-partial";
    LoadingState["Reloading"] = "reloading";
    LoadingState["Loaded"] = "loaded";
    LoadingState["Error"] = "error";
    LoadingState["ErrorPartial"] = "error-partial";
})(LoadingState || (LoadingState = {}));
//# sourceMappingURL=types.js.map